import React from "react";
import { Icon } from "antd";
import { formatCurrency, formatNumber } from "./utils";

// props.datos: { productosTotales, productosStockBajo, productosSinStock, valorInventario: { pen, usd } }
export default function ListaInventario(props) {
    const moneda = props.moneda || "PEN";
    const datos = props.datos || {};
    const valorInventario = (datos.valorInventario || {})[moneda === "USD" ? "usd" : "pen"];

    const items = [
        { icon: "appstore", color: "#2563eb", fondo: "#dbeafe", nombre: "Productos Totales", valor: formatNumber(datos.productosTotales, 0), colorValor: "#111827" },
        { icon: "warning", color: "#d97706", fondo: "#fef3c7", nombre: "Productos con Stock Bajo", valor: formatNumber(datos.productosStockBajo, 0), colorValor: "#d97706" },
        { icon: "stop", color: "#dc2626", fondo: "#fee2e2", nombre: "Productos Sin Stock", valor: formatNumber(datos.productosSinStock, 0), colorValor: "#dc2626" },
        { icon: "database", color: "#2563eb", fondo: "#dbeafe", nombre: "Valor Total de Inventario", valor: formatCurrency(valorInventario, moneda), colorValor: "#2563eb" },
    ];

    return (
        <div className="general-lista">
            {items.map((item) => (
                <div className="general-lista-item" key={item.nombre}>
                    <div className="general-lista-icon" style={{ backgroundColor: item.fondo, color: item.color }}>
                        <Icon type={item.icon} />
                    </div>
                    <span className="general-lista-nombre" title={item.nombre}>{item.nombre}</span>
                    <span className="general-lista-valor" style={{ color: item.colorValor }}>{item.valor}</span>
                </div>
            ))}
        </div>
    );
}
